<section class="container">
  <div class="page-header-container">
    <div class="page-title-container">
      <h1 class="page-title" translate>Classes</h1>
    </div>
    <div>
      <mat-form-field>
        <mat-label>Academic Years: </mat-label>
        <mat-select id="regSelect" [(ngModel)]="selectedReg">
          <mat-option value="" translate>All</mat-option>
          <mat-option *ngFor="let reg of regs" [value]="reg">{{
            reg
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="card-grid py-2">
    <mat-card
      class="class-card"
      *ngFor="let classItem of filteredClasses()"
      (click)="navigateTo(classItem)"
      appearance="outlined"
    >
      <mat-card-header>
        <mat-card-title>{{ classItem.title }}</mat-card-title>
        <mat-card-subtitle>Reg: {{ classItem.reg }}</mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <p class="medium-section">
          {{ classItem.medium }} | {{ classItem.section }}
        </p>
        <p class="subject">{{ classItem.subject }}</p>
      </mat-card-content>
    </mat-card>
  </div>
</section>
